// User-facing Italian labels for the moto-wizard fields that can block "Next".
export const STEP_FIELD_LABELS = {
  // Step 1 — Dati del Veicolo
  moto_plate: 'Targa',
  is_old_plate: 'Tipo di Targa',
  start_immatricolation_month: 'Mese di immatricolazione',
  start_immatricolation: 'Anno di immatricolazione',
  moto_brand_code: 'Marca',
  moto_model_code: 'Modello',
  moto_version_code: 'Versione',
  vehicle_parking: 'Dove parcheggi',
  theft_protection_code: 'Antifurto',
  vehicle_usage: 'Uso del veicolo',
  predicted_km: 'Km percorsi in un anno',
  vehicle_purchased_month: 'Mese di acquisto del veicolo',
  vehicle_purchased_year: 'Anno di acquisto del veicolo',
  vehicles_owned: 'Veicoli posseduti',
  weight: 'Peso',
  power: 'Potenza',

  // Step 2 — Dati Personali
  gender: 'Il contraente è',
  name: 'Nome',
  surname: 'Cognome',
  business_name: 'Ragione sociale',
  vat_number: 'Partita IVA',
  company_type: 'Tipologia azienda',
  date_of_birth: 'Data di nascita',
  commune_of_birth_code: 'Comune di nascita',
  province_of_birth_code: 'Provincia di nascita',
  born_abroad: "Nato all'estero",
  residence_commune_code: 'Comune di residenza',
  residence_province_code: 'Provincia di residenza',
  postal_code: 'CAP',
  address: 'Indirizzo',
  house_number: 'Numero civico',
  children: 'Figli conviventi',
  civil_status_id: 'Stato civile',
  education_level_id: 'Titolo di studio',
  profession_id: 'Professione',
  contractor_is_driver: 'Il contraente è anche il conducente abituale del veicolo?',
  contractor_is_owner: 'Il contraente è anche proprietario della moto?',
  driving_license_year: 'Anno patente',

  // Step 3 — Dati Assicurativi
  policy_effective_date: 'Data di decorrenza/scadenza polizza',
  other_drivers: 'Ci sono altri conducenti?',
  youngest_age_driver: 'Età del conducente più giovane con patente di guida',
  youngest_age_family_member: 'Età del membro più giovane della famiglia con la patente di guida',
  violations_data: 'Dettaglio sinistri',
  merit_class: 'Classe di merito',
  modified_vehicle: 'Dichiarazione conducente (patente/veicolo)',
  guide_type: 'Tipo di guida',
  inherit_merit_class: 'Classe di merito di un altro veicolo assicurato',
  insurance_type: 'Tipo di assicurazione (Veicolo già assicurato / Nuovo rischio)',
  first_insuranced_year: 'Prima assicurazione in 6 anni',
  payment_frequency: 'Frequenza di pagamento',
  previous_company: 'Compagnia assicurativa attuale',

  // Step 4 — Dati di Contatto
  email: 'Email',
  phone: 'Telefono',
};

// Fields that live inside each step's collapsed "Detagli" panel, keyed by step index.
export const COLLAPSED_PANEL_FIELDS_BY_STEP = {
  1: ['weight', 'power', 'vehicle_parking', 'theft_protection_code', 'vehicle_usage', 'predicted_km', 'vehicles_owned'],
  2: ['civil_status_id', 'education_level_id', 'profession_id', 'children'],
  3: ['other_drivers', 'youngest_age_driver', 'youngest_age_family_member', 'violations_data', 'modified_vehicle'],
};

export const getBlockingFields = (errors, stepFields) => (stepFields || []).filter((field) => errors && errors[field]);

// Keep the list short enough to stay readable inside a toast.
export const buildMissingFieldsMessage = (fields, labels = STEP_FIELD_LABELS, max = 3) => {
  const names = (fields || []).map((field) => labels[field] || field);
  if (names.length > max) {
    return `Compila i campi obbligatori: ${names.slice(0, max).join(', ')} e altri ${names.length - max}.`;
  }
  return `Compila i campi obbligatori: ${names.join(', ')}.`;
};
